import { store } from '../lib/store/store';

export const generateImageUrl = (s3Key: string | null | undefined) => {
  if (!s3Key || !s3Key.length) return;

  const host = store.getState().app.s3Host;

  let url = '';

  if (host) {
    const cleanHost = host.endsWith('/') ? host.slice(0, -1) : host;
    const cleanKey = s3Key.startsWith('/') ? s3Key.slice(1) : s3Key;

    url = new URL(`${cleanHost}/${cleanKey}`).toString();
  }

  return url;
};
